import { render, staticRenderFns } from "./enInforDetail.vue?vue&type=template&id=70056a99&scoped=true"
import script from "./enInforDetail.vue?vue&type=script&lang=js"
export * from "./enInforDetail.vue?vue&type=script&lang=js"
import style0 from "./enInforDetail.vue?vue&type=style&index=0&id=70056a99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70056a99",
  null
  
)

export default component.exports